<ng-container *transloco="let t; read: 'inbox-voicemail-detail'">
  <app-inbox-voicemail-play [row]="row"></app-inbox-voicemail-play>
  <app-inbox-voicemail-detail-handled-by-button [row]="row"></app-inbox-voicemail-detail-handled-by-button>
  <app-inbox-voicemail-detail-dial-phone-button [row]="row"></app-inbox-voicemail-detail-dial-phone-button>
</ng-container>
